const prefix = '@@STATUS_SELECT';

export const STATUS_SELECT_CHANGE = `${prefix}__CHANGE`;
export const STATUS_SELECT_RESET = `${prefix}__RESET`;
export const STATUS_SELECT_SET_DATA = `${prefix}__SET_DATA`;
